module.exports = __webpack_public_path__ + "static/media/KMH_4962.86c9d840.jpg";